var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from "react";
import { useEffect, useRef, useState } from "react";
import { c } from "./c";
import Arrow from "./Arrow";
export const CountrySelector = (props) => {
    const selector = useRef();
    const [imgErr, setImgErr] = useState(true);
    const [selectedOption, setSelectedOption] = useState();
    const activeOption = useRef();
    const shouldShowDrpDwn = useRef(true);
    const drpBtn = useRef();
    const selectorInput = useRef();
    const [search, setSearch] = useState("");
    const noOptions = useRef(false);
    useEffect(() => {
        const img = new Image();
        img.onload = () => {
            setSelectedOption(props.flags === undefined || props.flags
                ? props.defaultCountry.fg
                : props.fullIsoCode
                    ? props.defaultCountry.c
                    : props.defaultCountry.c_sm);
            setImgErr(false);
        };
        img.onerror = () => {
            setSelectedOption(props.fullIsoCode ? props.defaultCountry.c : props.defaultCountry.c_sm);
            setImgErr(true);
        };
        img.src = c[0].fg;
    }, []);
    useEffect(() => {
        window.onclick = function (event) {
            if (event.target &&
                event.target.className !==
                    "react-number-formatter-dropbtn" &&
                event.target &&
                event.target.className !==
                    "react-number-formatter-dropdown-input") {
                selector.current && selector.current.classList.remove("show");
            }
        };
        window.ontouchstart = function (event) {
            if (event.target &&
                event.target.className !==
                    "react-number-formatter-option" &&
                event.target &&
                event.target.className !==
                    "react-number-formatter-dropbtn" &&
                event.target &&
                event.target.className !==
                    "react-number-formatter-dropdown-input" &&
                event.target.className !==
                    "react-number-formatter-option-no-search") {
                selector.current && selector.current.classList.remove("show");
            }
        };
    }, []);
    const getSelector = () => {
        if (drpBtn.current) {
            const offset = drpBtn.current.getBoundingClientRect();
            if (offset.bottom > 500) {
                selector.current &&
                    shouldShowDrpDwn.current &&
                    selector.current.classList.add("react-number-formatter-dropdown-content-top");
            }
            else {
                selector.current &&
                    shouldShowDrpDwn.current &&
                    selector.current.classList.remove("react-number-formatter-dropdown-content-top");
            }
        }
        selector.current &&
            shouldShowDrpDwn.current &&
            selector.current.classList.toggle("show");
    };
    const menuStyle = props.onlyCountries
        ? props.onlyCountries.length < 5
            ? {
                height: "auto",
            }
            : {}
        : {};
    const selectOption = (country, index) => {
        changeCountry(country["f"], country["d"], country["p"]);
        setSelectedOption((props.flags === undefined || props.flags) && !imgErr
            ? country["fg"]
            : props.fullIsoCode
                ? country["c"]
                : country["c_sm"]);
        activeOption.current = index;
    };
    const countrySelectorStyle = { borderRadius: "4px 0px 0px 4px" };
    const changeCountry = (format, code, placeholder) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        props.setFormat({
            format,
            placeholder,
        });
        (_a = props.mainInput) === null || _a === void 0 ? void 0 : _a.focus();
        props.setCountryCode(code);
    });
    const countryOptions = (ar) => {
        const options = props.onlyCountries
            ? ar.filter((country) => {
                var _a, _b, _c, _d;
                const name = country["n"].toLocaleLowerCase();
                if (search) {
                    return ((((_a = props.onlyCountries) === null || _a === void 0 ? void 0 : _a.includes(country["c"])) ||
                        ((_b = props.onlyCountries) === null || _b === void 0 ? void 0 : _b.includes(country["c_sm"]))) &&
                        name.startsWith(search));
                }
                else {
                    return (((_c = props.onlyCountries) === null || _c === void 0 ? void 0 : _c.includes(country["c"])) ||
                        ((_d = props.onlyCountries) === null || _d === void 0 ? void 0 : _d.includes(country["c_sm"])));
                }
            })
            : ar.filter((country) => {
                const name = country["n"].toLocaleLowerCase();
                if (search) {
                    return name.startsWith(search);
                }
                else {
                    return country;
                }
            });
        shouldShowDrpDwn.current =
            (options.length && options.length > 1) || search ? true : false;
        if (!shouldShowDrpDwn.current || props.disabled) {
            drpBtn.current &&
                drpBtn.current.classList.add("react-number-formatter-dropbtn-false");
        }
        noOptions.current = options.length ? false : true;
        return options;
    };
    return (React.createElement("div", { className: "react-number-formatter-dropdown-parent" },
        React.createElement("button", { disabled: props.disabled, ref: (ref) => (drpBtn.current = ref), className: "react-number-formatter-dropbtn", style: countrySelectorStyle, onClick: getSelector, type: "button" },
            React.createElement("div", { className: "react-number-formatter-dropbtn-text" },
                (props.flags === undefined || props.flags) && !imgErr ? (React.createElement("img", { src: selectedOption, className: "react-number-formatter-selected-flag zoom", alt: selectedOption })) : (React.createElement("span", null, selectedOption)),
                (props.onlyCountries &&
                    props.onlyCountries.length < 2 &&
                    (props.onlyCountries[0] === props.defaultCountry.c_sm ||
                        props.onlyCountries[0] === props.defaultCountry.c)) ||
                    props.disabled ? ("") : (React.createElement("div", { className: "react-number-formatter-arrow-parent" },
                    React.createElement(Arrow, { color: "rgb(108, 108, 108)" }))))),
        React.createElement("div", { style: menuStyle, ref: (ref) => (selector.current = ref), className: "react-number-formatter-dropdown-content" },
            (props.searchOption === undefined || props.searchOption) && (React.createElement("div", { className: "react-number-formatter-dropdown-input-parent" },
                React.createElement("input", { type: "search", placeholder: "Search...", ref: (ref) => (selectorInput.current = ref), className: "react-number-formatter-dropdown-input", onChange: (e) => {
                        setSearch(e.currentTarget.value.toLocaleLowerCase());
                    } }))),
            React.createElement("div", { className: "react-number-formatter-dropdown-content-child" },
                React.createElement("div", null,
                    countryOptions(c).map((country, index) => {
                        return (React.createElement("button", { key: index, onClick: () => {
                                selectOption(country, index);
                            }, className: "react-number-formatter-option", type: "button" },
                            (props.flags === undefined || props.flags) && !imgErr ? (React.createElement("img", { src: country["fg"], alt: "", className: "react-number-formatter-flag" })) : (""),
                            " ",
                            country["n"],
                            " ",
                            country["d"]));
                    }),
                    noOptions.current && (React.createElement("p", { className: "react-number-formatter-no-option" }, "No options")))))));
};
